var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"builder-input",domProps:{"innerHTML":_vm._s(_vm.previewObj.html)}})}
var staticRenderFns = []

export { render, staticRenderFns }